import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgChevronUp = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M18.6877 16.7223C18.8977 16.5323 18.9977 16.2623 18.9977 16.0023C18.9977 15.7523 18.9077 15.5023 18.7177 15.3123L11.9977 8.30231L5.27769 15.3123C4.89769 15.7123 4.90769 16.3423 5.30769 16.7223C5.70769 17.1023 6.33769 17.0923 6.71769 16.6923L11.9977 11.1923L17.2777 16.6923C17.6577 17.0923 18.2877 17.1023 18.6877 16.7223Z'
      fill='#0062D1'
    />
  </svg>
);
export default SvgChevronUp;
